import React from "react";
import { Image, Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./GameScrollGuideIndicator.scss";
import ImageScrollUpAnimation from "../../../images/scroll-up-animation.gif";

export enum GameScrollGuideMessages {
  SWIPE_UP = "swipe_up_for_more_games",
  END = "you_have_reached_the_end",
}

interface GameScrollGuideIndicatorProps {
  message: GameScrollGuideMessages;
}

export default function GameScrollGuideIndicator({
  message,
}: GameScrollGuideIndicatorProps) {
  const { t } = useTranslation("games");

  return (
    <Stack className="align-items-center GameScrollGuideIndicator">
      {message === GameScrollGuideMessages.SWIPE_UP && (
        <Image
          src={ImageScrollUpAnimation}
          alt="arrows pointing up"
          width={48}
          height={48}
          className="Animation"
        />
      )}
      <p className="Grotesk GameScrollGuideMessage">{t(message)}</p>
    </Stack>
  );
}
